/**
 * @render react
 * @name VerdictExtra
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import { Icon } from 'Components/atoms/Icon';
import { Text } from 'Components/atoms/Text';

import './_style.scss';

/**
 * VerdictExtra component
 * @param {string} label - Label of the component
 * @param {string} icon - Icon to show instead of the label
 * @param {string} content - HTML content of the component
 * @param {bool} showLabel - shows the label and the icon if true
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {Object} extraClassNames - Extra class names to be applied to the component
 * @param {Object} context - Extra information coming from Polaris provider.
 */
const VerdictExtra = (
  {
    icon,
    label,
    content,
    showLabel,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  },
) => {
  /**
   * Function that returns the label+icon if showLabel is true,
   * otherwise, if icon is present, returns icon
   * else it returns the label
   */
  const getLabel = () => {
    if (showLabel) {
      return (
        <>
          {label && <span className={`${cssPrefix}__verdict-extra--label-text`}>{label}</span>}
          {icon && <Icon icon={icon} />}
        </>
      );
    }

    return (
      icon ? <Icon icon={icon} /> : label
    );
  };

  return (
    <div
      className={classNames({
        [`${cssPrefix}__verdict-extra`]: loadStyles,
        ...extraClassNames,
      })}
    >
      <div className={`${cssPrefix}__verdict-extra--label`}>
        { getLabel() }
      </div>

      {typeof content === 'object' && <Text>{content}</Text>}
    </div>
  );
};

/**
 * Valid props
 */
VerdictExtra.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.bool,
  ]),
  showLabel: PropTypes.bool,
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  context: PropTypes.shape(),
};

/**
 * Default props
 */
VerdictExtra.defaultProps = {
  icon: '',
  label: '',
  content: false,
  showLabel: false,
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(VerdictExtra);
